import {Component, Inject, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ModalData} from "../../../shared-module/types/modal-data.type";
import ModalService, {ModalRef} from "../../../shared-module/services/modal.service";

import Product, {TelevisionProduct} from "../../../shared-module/model/product.model";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {CurrencyComponent} from "../../../shared-module/components/currency/currency.component";
import {DividerComponent} from "../../../shared-module/components/divider/divider.component";
import {IconComponent} from "../../../shared-module/components/icon/icon.component";
import {
  ProductPriceDisplayComponent
} from "../../../shared-module/components/product-price-display/product-price-display.component";
import {ProductState} from "../../../shared-module/enums/product-state";
import {AuthService} from "../../../shared-module/services/auth.service";
import {SuccessModalComponent} from "../../../shared-module/components/success-modal/success-modal.component";
import ProductStore from "../../../shared-module/services/Stores/product.store";
import Subscription from "../../../shared-module/model/subscription.model";
import {ModalEventTypes} from "../../../shared-module/enums/modal.event";

@Component({
    selector: 'app-product-order-modal',
    imports: [
    ButtonComponent,
    CurrencyComponent,
    DividerComponent,
    IconComponent,
    ProductPriceDisplayComponent
],
    templateUrl: './product-order-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-order-modal.component.scss'
})
export class ProductOrderModalComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly modalService: ModalService = inject(ModalService);
  readonly modalRef: ModalRef<ProductOrderModalComponent> = inject<ModalRef<ProductOrderModalComponent>>(ModalRef);
  private readonly productStore: ProductStore = inject(ProductStore);

  protected isLoading: boolean = false;
  protected readonly ProductState: typeof ProductState = ProductState;

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Inject(ModalData) public product: TelevisionProduct) {}

  public ngOnInit(): void {
    this.authService.getSelectedSubscription().subscribe((subscription: Subscription | null) => {
      if (!subscription) {
        return;
      }
      this.productStore.reset();
      this.productStore.forParent('subscriptions', subscription);
    });
  }

  protected order(): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.productStore.create(this.product).subscribe((newProduct: Product) => {
      this.isLoading = false;
      this.modalRef.close(newProduct, ModalEventTypes.Confirmed);

      this.modalService.open(SuccessModalComponent, null, {
        title: 'Bedankt voor de bestelling!',
        subtitle: 'We hebben je verzoek in goede orde ontvangen en gaan direct aan de slag om het product beschikbaar te stellen.',
        width: '500px',
        showCloseButton: true,
      });
    });
  }
}
